export default __webpack_public_path__ + "static/media/MaterialIconsOutlined-Regular.89f5a996.ttf";